import React from 'react';

import styled from 'styled-components';
import { Form, Radio, Tooltip } from 'antd';

import { useImmerAtom } from 'jotai-immer';
import * as Constants from '../../views/diagnosis/constants';
import { kidneyAtom } from './atom';
import { useHandleEventValue } from './hooks';

export default function Index({ disease, getFieldDecorator, radioButtonMessage, color }) {
  const [, setKidney] = useImmerAtom(kidneyAtom);
  const handleSelectionClick = useHandleEventValue({ setImmerState: setKidney });

  return (
    //
    <Form.Item>
      {getFieldDecorator('kindKidney', {
        rules: [
          {
            required: true,
            message: radioButtonMessage
          }
        ]
      })(
        <CheckDiagnosisSection>
          <QueryTitle>주문하려는 식단을 선택해주세요</QueryTitle>
          <SubQueryTitle style={{ color: '#CECECE' }}>
            *염분조절 식단은 식단형 식사관리 식품이 아닙니다.
            <Tooltip
              placement="bottom"
              title={`비투석 식단: 단백질, 염분, 칼륨, 인이 조절된 식단
/ 염분조절 식단: 단백질 조절 없이 염분만 조절된 식단`}
            >
              <br />
              <span style={{ color }}>비투석과 염분조절은 무슨 차이인가요?</span>
            </Tooltip>
          </SubQueryTitle>
          <Radio.Group buttonStyle="solid">
            {disease === 'kideny' && Constants?.KIND_KIDNEY.map(item => {
              const { name, value } = item;
                return (
                <SelectBox key={value} onClick={handleSelectionClick('kidneyStatus')} value={value}>
                  {name}
                  </SelectBox>
                );
              })}
            {disease === 'kidney_trial' && Constants?.KIND_KIDNEY_TRIAL.map(item => {
              const { name, value } = item;
              return (
                <SelectBox key={value} onClick={handleSelectionClick('kidneyStatus')} value={value}>
                  {name}
                </SelectBox>
              );
            })}
          </Radio.Group>
        </CheckDiagnosisSection>
      )}
    </Form.Item>
  );
}

const RelayionTypeSection = styled.div`
  .ant-radio-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .ant-input-affix-wrapper .ant-input:not(:last-child) {
    font-size: 1.8rem;
    ${props => props.theme.device.md} {
      font-size: 2.4rem;
    }
  }
`;

const QueryTitle = styled.div`
  word-break: keep-all;
  font-size: 2.1rem;
  font-weight: 700;
  color: #323232;
  margin-bottom: 2rem;
  margin-top: 5rem;
  ${props => props.theme.device.md} {
    margin-top: 10rem;
    font-size: 2.9rem;
  }
`;
const SelectBox = styled(Radio.Button)`
  height: 6rem;
  word-break: keep-all;
  margin: 0.5rem 0;
  width: calc(50% - 1.6rem);
  line-height: ${props => (props.lineHight ? '4rem' : '6rem')};
  span {
    font-size: 1.6rem;
  }
  ${props => props.theme.device.md} {
    height: 7.2rem;
    line-height: ${props => (props.lineHight ? '6.5rem' : '7.2rem')};
    span {
      font-size: 2.4rem;
      word-break: keep-all;
    }
  }
`;
const SubQueryTitle = styled.div`
  word-break: keep-all;
  font-size: 1.5rem;
  font-weight: 400;
  color: #323232;
  margin-bottom: ${props => (props.isText ? '0' : '2rem')};

  ${props => props.theme.device.md} {
    font-size: 2rem;
  }
`;
const CheckDiagnosisSection = styled(RelayionTypeSection)``;
